import React from "react";
import { useNavigate } from "react-router-dom";

const Confirmation = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/MainBody04.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#0b0b0b",
      }}
    >
      {/* subtle overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Card wrapper */}
      <div className="relative z-10 w-full max-w-md">
        {/* Glass card */}
        <div
          className="relative p-8 rounded-2xl text-center"
          style={{
            background: "rgba(0,0,0,0.65)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(255,255,255,0.15)",
            boxShadow: "0 25px 60px rgba(0,0,0,0.7)",
          }}
        >
          {/* Glow ring */}
          <div className="absolute inset-0 rounded-2xl pointer-events-none shadow-[0_0_25px_rgba(168,85,247,0.35)]"></div>

          {/* Success Icon */}
          <div className="flex justify-center mb-4 relative z-10">
            <div className="w-16 h-16 rounded-full bg-green-600/20 flex items-center justify-center border border-green-500">
              <svg
                className="w-8 h-8 text-green-500"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-green-400 mb-2 relative z-10">
            Submission Successful
          </h2>

          <p className="text-gray-300 text-sm mb-6 relative z-10">
            Your Video KYC details have been submitted successfully.
            Our team will review the information and proceed further.
          </p>

          <button
            onClick={() => navigate("/home")}
            className="btn-kyc w-full relative z-10"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/Black2.png)`,
              backgroundSize: "100% 100%",
              backgroundRepeat: "no-repeat",
              color: "#fff",
              padding: "12px",
              fontWeight: "600",
            }}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
